import usePrefix from '@/hooks/usePrefix';
import { PickerWithCheck } from '@/components/Bicester';
import React from 'react';
import { ControlLabel, FormGroup } from 'rsuite';
import { ItemDataType } from 'rsuite5/esm/@types/common';
import { FormControl } from '@/components/formik-rsuite';

const BicesterCardPickerWithCheck = ({
  isEdit = true,
  notEditable = false,
  required = false,
  label,
  formKey,
  currentLabel,
  pickerData,
  cleanable = true,
  checkKey,
  checkLabel,
  onCheck,
  labelWeight,
  contentWeight,
}: {
  isEdit?: boolean;
  notEditable?: boolean; // true为不可编辑
  required?: boolean; // 是否必填
  label: string;
  formKey: string;
  currentLabel?: string; // 接收的数据不在下拉框中，非编辑状态下展示
  pickerData: ItemDataType[];
  cleanable?: boolean;
  checkKey: string; // checkbox单选框的key
  checkLabel: string; // checkbox单选框的label
  onCheck?: (key: string, value: any) => void; // 选中checkbox时触发
  labelWeight?: number; // label的flex占比
  contentWeight?: number; // content的flex占比
}) => {
  const { prefix, classname } = usePrefix('bicester-card-item');

  return (
    <div className="bicester-card-item-wrap">
      <FormGroup className={`${classname} bicester-card-pickerwithcheck`}>
        <ControlLabel
          className={prefix('label')}
          style={{ ...(labelWeight && { flex: labelWeight }) }}
        >
          <div className={prefix('label-text')}>{label}</div>
          <div
            className={`${prefix('label-divider')} ${isEdit && required ? 'required' : ''}`}
          ></div>
        </ControlLabel>
        <div
          className={prefix('content-wrap')}
          style={{ ...(contentWeight && { flex: contentWeight }) }}
        >
          <FormControl
            className={prefix('content')}
            name={formKey}
            accepter={PickerWithCheck}
            isEdit={isEdit && !notEditable}
            cleanable={cleanable}
            data={pickerData || []}
            currentLabel={currentLabel}
            checkKey={checkKey}
            checkLabel={checkLabel}
            onCheck={(key, value) => onCheck && onCheck(key, value)}
          />
        </div>
      </FormGroup>
    </div>
  );
};

export default BicesterCardPickerWithCheck;
